/**
 * base64转码为file
 * @params 图片base64
 * @params 图片name
 */ 
function Base64ToFile(base64, name) {
    var arr = base64.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], name, { type: mime });
}

/**
 * url转码为base64
 * @params 图片url
 */ 
function URLToBase64(url) {
    // 一定要设置为let，不然图片不显示
    var image = new Image();
    // 解决跨域问题
    image.setAttribute('crossOrigin', 'anonymous');
    var imageUrl = url;
    image.src = imageUrl
    // image.onload为异步加载
    image.onload = () => {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var quality = 0.8;
        // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        var urlBase64 = canvas.toDataURL('image/jpeg', quality);
        return urlBase64;
    }
}
/** 
 * 压缩图片，压缩为jpeg格式、base64
 * @params img
 * @params percent压缩大小
 */ 
function compressImg(img, percent) {
    // 生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 宽高比例
    var width = img.width * percent;
    var height = img.height * percent;
    canvas.width = width;
    canvas.height = height;
    // 铺底色
    ctx.fillStyle = '#fff';
    // 绘制矩形
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    // 绘制图像
    ctx.drawImage(img, 0, 0, width, height);

    // 进行压缩
    var ndata = canvas.toDataURL('image/jpeg', percent);
    return ndata;
};


export default {
    // 压缩图片
    img(img, percent) {
        return compressImg(img, percent);
    },
    // url转base64
    URLToBase64(url){
        return URLToBase64(url);
    },
    // base64转url
    Base64ToFile(base64, name){
        return Base64ToFile(base64, name);
    },
}